import { render, staticRenderFns } from "./add-edit-proceso-electoral-gasto.vue?vue&type=template&id=5cc5b95f&"
import script from "./add-edit-proceso-electoral-gasto.vue?vue&type=script&lang=js&"
export * from "./add-edit-proceso-electoral-gasto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports